<template>
    <div class="calculator-containers" ref="calculatorContainer">
        <h2 class="calculator-title">{{ $t("page.tariffs.calculate_cost") }}</h2>
        <div class="list-slider">
            <div class="slider-month">
                <div class="input-container helps">
                    <p class="slider-subtitle" style="width: 100%; margin-bottom: 15px">
                        {{ $t("page.tariffs.amount_months") }}
                    </p>
                    <count-month
                        :countMonth="countNumbers.months"
                        @onMonthsButton="chooseCountMonths"
                    />
                </div>
            </div>
            <div
                :class="`slider-${msgr.value}`"
                v-for="msgr in MESSENGERS"
                :key="msgr.value"
            >
                <div class="input-container">
                    <p class="slider-subtitle">
                        {{ $t("page.tariffs.amount_numbers") }} {{ msgr.title }}
                    </p>
                    <input
                        type="number"
                        class="input"
                        v-model="countNumbers[msgr.value]"
                        min="0"
                        @input="handleThumbValueChanged(msgr.value, $event.target.value)"
                    />
                </div>
                <slider
                    :maxValue="20"
                    :start="countNumbers[msgr.value]"
                    :price="tariffPriceOfMonth[msgr.value]"
                    @thumbValueChanged="handleThumbValueChanged(msgr.value, $event)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
// core
import {reactive, ref} from "vue";
import {useStore} from "vuex";
// components
import Slider from "@/components/Recurring/Slider.vue"
import CountMonth from "@/components/Recurring/CountMonth.vue"

// data
import MESSENGERS from "@/data/messengers"

const props = defineProps({
    tariffPriceOfMonth: Object,
    updatedData: Object
})

const emit = defineEmits(["calculatePayloadUpdated"])

const store = useStore();
const countNumbers = reactive({
    viber: props.updatedData?.length ? props.updatedData.viber : 0,
    telegram: props.updatedData.telegram?.length ? props.updatedData.telegram : 0,
    whatsapp: props.updatedData.whatsapp?.length ? props.updatedData.whatsapp : 0,
    months: props.updatedData.months ? props.updatedData.months : 1,
});

const calculatorContainer = ref(null);
const thumbValueInParent = ref(null);

const chooseCountMonths = (number) => {
    countNumbers.months = number;
    emit("calculatePayloadUpdated", {count: countNumbers})
}

const handleThumbValueChanged = (sliderType, value) => {
    thumbValueInParent.value = value;
    countNumbers[sliderType] = value;
    store.state.countNumbers = countNumbers;
    emit("calculatePayloadUpdated", { count: countNumbers });
}
</script>

<style scoped lang="scss">
.helps {
    align-items: center;
    flex-direction: column;
}

.slider-viber {
    padding: 20px 20px 50px 20px;
    border-radius: 12px;
    background: var(--block-color);
}

.slider-telegram {
    margin-top: 20px;
    padding: 20px 20px 50px 20px;
    border-radius: 12px;
    background: var(--block-color);
}

.slider-whatsapp {
    margin-top: 20px;
    padding: 20px 20px 50px 20px;
    border-radius: 12px;
    background: var(--block-color);
}

.calculator-containers {
    padding: 30px 25px 40px 25px;
    border: 1px solid lightgrey;
    border-radius: 10px;
    margin-top: 25px;
}

.input {
    width: 115px;
    height: 50px;
    padding-left: 15px;
    border: 1px solid lightgrey;
    border-radius: 7px;
    font-size: 14px;
}

.input-container {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
}

.slider-subtitle {
    font-family: Gilroy;
    font-weight: 500;
    margin-right: 15px;
    font-size: 18px;
}

.calculator-title {
    font-family: "Gilroy";
    font-size: 24px;
    font-weight: 500;
    text-transform: uppercase;
    margin-bottom: 40px;
}

.slider-month {
    margin-bottom: 40px;
}

@media screen and (max-width: 640px) {
    .calculator-containers {
        padding: 30px 10px 40px 10px;
    }

    .input-container {
        display: block;
        margin-bottom: 50px;

        .slider-subtitle {
            font-size: 12px;
            line-height: 16px;
            margin-bottom: 10px;
        }

        input {
            width: 105px;
            height: 44px;
            font-size: 12px;
        }
    }
}

@media screen and (max-width: 1024px) {
    .calculator-containers {
        padding: 30px 15px 40px 15px;
    }
}
</style>
